import { IField } from "../../omnia"

export function getFieldErrorMessages(vm: { target: IField, effectiveArea: number }) {

    return {

        "WorkingArea/area": () => `The working area cannot exceed the whole area (${vm.target.WholeArea} ha)`,

        "NitrogenSpreadArea/area": () => `The nitrogen spreabable area cannot exceed ${vm.effectiveArea} ha`,

        "ManureSpreadArea/area": () => `The manure spreabable area cannot exceed ${vm.effectiveArea} ha`

    }

}
